import { render, staticRenderFns } from "./managment_nfc.vue?vue&type=template&id=2d12b905&scoped=true"
import script from "./managment_nfc.vue?vue&type=script&lang=js"
export * from "./managment_nfc.vue?vue&type=script&lang=js"
import style0 from "./managment_nfc.vue?vue&type=style&index=0&id=2d12b905&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d12b905",
  null
  
)

export default component.exports